// Rechtstexte der IT-Recht Kanzlei (München) – per iframe eingebunden.
// Die Texte liegen auf dem Server der Kanzlei und aktualisieren sich automatisch.
export const LEGAL_DOCS = {
  impressum: { label: "Impressum", url: "https://itrk.legal/1AmR.0.19B6-de-iframe.html" },
  agb: { label: "AGB", url: "https://itrk.legal/1AmR.bv.19B6-iframe.html" },
  datenschutz: { label: "Datenschutz", url: "https://itrk.legal/1AmR.bg.19B6-iframe.html" },
};
